import Dropzone from 'dropzone';
import { Translator, $, Routing, utils } from '../common/adapters/legacy-to-modules-adapter';

Dropzone.autoDiscover = false;

$(() => {
  const dropzone = new Dropzone('.support-popup-dropzone', {
    accept(file, done) {
      let total = 0;

      $.each(this.getAcceptedFiles(), (i, f) => {
        total += f.size;
      });

      total += file.size;

      if (total > this.options.maxFilesize * 1024 * 1024) {
        return done(
          this.options.dictFileTooBig
            .replace('{{filesize}}', Math.round(total / 1024 / 10.24) / 100)
            .replace('{{maxFilesize}}', this.options.maxFilesize),
        );
      }

      return done();
    },
    addRemoveLinks: true,
    url: Routing.generate('visual_craft_videojet_support_popup_upload_file'),
    dictDefaultMessage: Translator.trans('Drop file(s) or click here to select'),
    dictFallbackMessage: Translator.trans("Your browser does not support drag'n'drop file uploads."),
    dictFallbackText: Translator.trans('Please use the fallback form below to upload your files like in the olden days.'),
    dictFileTooBig: Translator.trans('Attachment you attempt to add exceeds max. size limit {{maxFilesize}} Mb.'),
    dictInvalidFileType: Translator.trans("You can't upload files of this type."),
    dictResponseError: Translator.trans('Server responded with {{statusCode}} code.'),
    dictCancelUpload: Translator.trans('Cancel upload'),
    dictRemoveFile: Translator.trans('Remove file'),
    dictMaxFilesExceeded: Translator.trans('You can not upload any more files'),
    maxFilesize: 7,
  });

  const inputManager = {
    _$input: $('input[name="visual_craft_videojet_support[fileUris]"]'),

    add(name, uri) {
      const fileUris = this._getFileUris();
      fileUris[name] = uri;
      return this._setFileUris(fileUris);
    },

    remove(name) {
      const fileUris = this._getFileUris();
      delete fileUris[name];
      return this._setFileUris(fileUris);
    },

    _getFileUris() {
      let fileUris = this._$input.val() ? JSON.parse(this._$input.val()) : {};

      if (!fileUris) {
        fileUris = {};
      }

      return fileUris;
    },

    _setFileUris(fileUris) {
      return this._$input.val(JSON.stringify(fileUris));
    },
  };

  dropzone
    .on('success', (file, response) => inputManager.add(file.name, response))
    .on('removedfile', file => inputManager.remove(file.name))
    .on('error', (file, message) => {
      utils.notify.message('error', message, { timeout: 1000 });
      dropzone.removeFile(file);
    })
  ;
});



// WEBPACK FOOTER //
// ./src/VisualCraft/Bundle/VideoJetBundle/Resources/js/support-popup/dropzone.js